module.exports = __webpack_public_path__ + "static/media/Video.cdf24f10.svg";